<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Danh sách Yêu cầu thay đổi thông tin</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <input
              type="text"
              v-model.trim="search.textSearch"
              class="form-control f12 hc-37 text-search"
              placeholder="Merchant (Email/Tên/Mã hợp đồng)"
            />
          </div>
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian tạo"
              class="w-100"
              :ranges="false"
              @update="transformDate()"
              v-model="dateRange"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian tạo
                </label>
              </template>
            </DateRangePicker>
          </div>
          <div class="form-group">
            <DateRangePicker
              placeholder="Thời gian cập nhật"
              class="w-100"
              :ranges="false"
              @update="transformDateUpdate()"
              v-model="dateRangeUpdate"
              :locale-data="localeData"
            >
              <template v-slot:input="picker">
                <label
                  v-if="picker.startDate && picker.endDate"
                  style="min-width: 13.5em"
                  class="text-center font-size-12"
                >
                  {{ picker.startDate | formatDate }} - {{ picker.endDate | formatDate }}
                </label>
                <label v-else style="min-width: 13.5em" class="font-size-12 time-placeholder">
                  Thời gian cập nhật
                </label>
              </template>
            </DateRangePicker>
          </div>

          <div class="form-group">
            <Select2
              v-model="search.rootState"
              :options="transformStatuses(configInfoChange.stateChangeOverview)"
              placeholder="Trạng thái yêu cầu gốc"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.subState"
              :options="transformStatuses(configInfoChange.stateChangeDetailInfo)"
              placeholder="Trạng thái yêu cầu con"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.confirmState"
              :options="confirmStateOptions"
              placeholder="Trạng thái MC xác nhận"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.typeChange"
              :options="transformStatuses(configInfoChange.typeChangeInfo)"
              placeholder="Loại yêu cầu"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.additionalNew"
              :options="additionalOption"
              placeholder="Tình trạng bổ sung HS"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.fromSource"
              :options="transformStatuses(configInfoChange.fromSource)"
              placeholder="Nguồn tạo"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.customerType"
              :options="Config.customerType"
              placeholder="Loại khách hàng"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.signForm"
              :options="Config.formContract"
              placeholder="Phương thức ký"
            />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.mposStt"
              :options="Config.mposApprovalStatus"
              placeholder="Trạng thái duyệt của mPos"
            />
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(confirmState)="data">
                <span class="badge" :class="getConfirmStateClass(data.item.confirmState)">
                  {{ getConfirmStateText(data.item.confirmState) }}
                </span>
              </template>
              <template #cell(time)="data">
                <span class="text-center">
                  <p>TG Tạo:{{ data.item.createdDate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                  <p>TG CN:{{ data.item.modifiedDate | formatDate('HH:mm, DD/MM/YYYY') }}</p>
                </span>
              </template>
              <template #cell(merchant)="data">
                <span class="text-center">
                  <p>Email: {{ data.item.rootEmail }}</p>
                  <p>Tên MC: {{ data.item.rootMerchantName }}</p>
                  <p>Địa chỉ: {{ data.item.rootAddress }}</p>
                  <p>Mã YC: {{ data.item.rootChangeCode }}</p>
                  <p>Mã HĐ: {{ data.item.contractCode }}</p>
                </span>
              </template>
              <template #cell(status)="data">
                <span class="badge" :class="data.item.state">
                  {{ data.item.state | transfromMccName(configInfoChange.stateChangeOverview) }}
                </span>
                <span
                  class="badge additional"
                  v-if="data.item.additionalNew && data.item.additionalNew === true"
                >
                  Đã bổ sung thêm
                </span>
              </template>
              <template #cell(type)="data">
                <p v-for="(item, index) in data.item.subChangeInfos" :key="index">
                  <span class="badge mr-2" :class="item.typeChange">
                    {{ item.typeChange | transfromMccName(configInfoChange.typeChangeInfo) }}
                  </span>
                  <span class="badge mr-2" :class="item.state">
                    {{ item.state | transfromMccName(configInfoChange.stateChangeDetailInfo) }}
                  </span>
                  <span v-if="item.rejectBy" class="badge mr-2 reject">
                    Từ chối: {{ item.rejectBy }}
                  </span>
                  <span v-if="item.approveBy" class="badge mr-2 approve">
                    Duyệt: {{ item.approveBy }}
                  </span>
                </p>
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item class="dropdown-item" @click="detail(data.item.rootChangeId)"
                    ><span>&nbsp;</span>Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    v-if="
                      dataPermission &&
                      dataPermission?.includes('SCON_IN4CHANGE_CHANGE_STATUS_MC_CONFIRM')
                    "
                    class="dropdown-item"
                    @click="openStatusChangeModal(data.item.rootChangeId)"
                  >
                    <span>&nbsp;</span>MC xác nhận
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <StatusChangeModal
      modal-id="statusChangeModal"
      :req-id="selectedReqId"
      @confirm="handleStatusChange"
    />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import { ContractService } from '@/services/contract.service'
  import { CommonService } from '@/services/common.service'
  import moment from 'moment'
  import cloneDeep from 'lodash/cloneDeep'
  import StatusChangeModal from './StatusChangeModal.vue'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'time', label: 'Thời gian', thStyle: 'min-width: 150px' },
    { key: 'merchant', label: 'Merchant', thStyle: 'min-width: 150px' },
    { key: 'status', label: 'Trạng thái yêu cầu gốc', thStyle: 'min-width: 150px' },
    { key: 'confirmState', label: 'Trạng thái MC xác nhận', thStyle: 'min-width: 150px' }, // Thêm cột mới
    { key: 'type', label: 'Loại yêu cầu/ Trạng Thái/ Người duyệt', thStyle: 'min-width: 350px' },
    { key: 'createdByEmail', label: 'Người tạo', thStyle: 'min-width: 150px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'info-change',
    components: {
      StatusChangeModal,
    },
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        configInfoChange: {},
        dateRange: {
          startDate: null,
          endDate: null,
        },
        dateRangeUpdate: {
          startDate: null,
          endDate: null,
        },
        localeData: Config.localeData,
        additionalOption: [
          {
            id: 'true',
            text: 'Đã bổ sung thêm',
          },
        ],
        confirmStateOptions: [
          { id: 'ALL', text: 'Tất cả' },
          { id: 'UNKNOWN', text: 'Không xác định' },
          { id: 'WAITING', text: 'Chờ MC xác nhận' },
          { id: 'CONFIRMED', text: 'MC đã xác nhận' },
        ],
        selectedReqId: '',
      }
    },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
      this.getConfigInfoChange()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      getConfirmStateText(state) {
        const stateMap = {
          ALL: 'Tất cả',
          UNKNOWN: 'Không xác định',
          WAITING: 'Chờ MC xác nhận',
          CONFIRMED: 'MC đã xác nhận',
        }
        return stateMap[state] || state
      },

      getConfirmStateClass(state) {
        const classMap = {
          UNKNOWN: 'badge-secondary',
          WAITING: 'badge-warning',
          CONFIRMED: 'badge-success',
        }
        return classMap[state] || 'badge-light'
      },
      openStatusChangeModal(reqId) {
        this.selectedReqId = reqId
        this.$bvModal.show('statusChangeModal')
      },
      async handleStatusChange(data) {
        try {
          this.showLoading = true
          // Gọi API với data.reqId và data.status
          const res = await ContractService.changeStatus(data)
          if (res.code === 1000) {
            this.fetchData()
            this.showSuccessMx('Chuyển trạng thái thành công')
          } else {
            this.showFailMx(res.message)
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
        }
      },
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      preareData() {
        const data = cloneDeep(this.search)
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await ContractService.listInfoChange(params)
          if (response.code === 1000) {
            this.lists = response.data.data
            this.pagination.total = response.data.paging.total
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
        }
      },
      detail(id) {
        // this.$router.push({ path: `/info-change/${id}` })
        const routeData = this.$router.resolve({
          path: `/info-change/${id}`,
        })
        window.open(routeData.href, '_blank')
      },
      getConfigInfoChange() {
        return CommonService.getConfigInfoChange()
          .then(data => {
            if (data.success) {
              this.configInfoChange = data.data
            }
          })
          .catch(error => console.log(error))
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        this.dateRange = {
          startDate: null,
          endDate: null,
        }
        this.dateRangeUpdate = {
          startDate: null,
          endDate: null,
        }
        this.fetchData()
      },
      transformDate() {
        this.search.createdFromDate = moment(this.dateRange.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.createdToDate = moment(this.dateRange.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      transformDateUpdate() {
        this.search.modifiedFromDate = moment(this.dateRangeUpdate.startDate)
          .startOf('day')
          .add(7, 'hours')
          .valueOf()
        this.search.modifiedToDate = moment(this.dateRangeUpdate.endDate)
          .endOf('day')
          .add(7, 'hours')
          .valueOf()
      },
      transformStatuses(data) {
        return data.map(status => ({
          id: status.code,
          text: status.name,
        }))
      },
    },
  }
</script>
<style scoped>
  .c-poiter {
    cursor: pointer;
  }

  .ACTIVE {
    color: #fff;
    background-color: #28a745;
  }

  .WAITING_PROCESS {
    color: #fff;
    background-color: #c7c42c;
  }

  .CHANGE_BANK_ACCOUN_INFO {
    color: black;
    background-color: #f1e8d9;
  }

  .CHANGE_REPRESENT_INFO {
    color: black;
    background-color: #f1e8d9;
  }

  .category {
    width: 300px;
  }

  .WAITING_SUPPORT {
    color: black;
    background-color: #b9d6f3;
  }

  .approve {
    color: black;
    background-color: #87c0f8;
  }

  .reject {
    color: black;
    background-color: #e6a2a2;
  }

  .additional {
    color: black;
    background-color: #30d8a5;
    margin-left: 3px;
  }
</style>
